'use strict';
import * as T from 'prop-types';
import React from 'react';
import {Button} from '../../../components/buttons/Button';
import {NavigationBreadcrumb} from '../../../components/views/NavigationBreadcrumb';
import {ViewHeader} from '../../../components/views/ViewHeader';


export function SettingsViewUploadsHeaderView(props) {
  return (
    <ViewHeader
      className="LegacyHeader"
      showBackButton={true}
      onGoBack={props.onGoBack}
    >
      <div className="ProjectLayout__header">
        <div className="ProjectLayout__headerLeft">
          <NavigationBreadcrumb
            className="ProjectLayout__breadcrumb"
            path={props.breadcrumbPath}
          />
          <div className="ProjectLayout__title">
            {props.viewTitle}
          </div>
        </div>

        <div className="ProjectLayout__headerRight">
          <Button
            className="SettingsViewUploadsHeader__retryButton"
            label={props.retryLabel}
            onClick={props.onClickRetry}
          />
        </div>
      </div>
    </ViewHeader>
  );
}

SettingsViewUploadsHeaderView.propTypes = {
  className: T.string,

  onGoBack: T.func,
  onClickRetry: T.func,

  viewTitle: T.string,
  retryLabel: T.string,
};



// WEBPACK FOOTER //
// ./src/js/settings/components/SettingsViewUploadsHeader/SettingsViewUploadsHeaderView.js